module.exports = __webpack_public_path__ + "809d305cdad7f53f8ac7bcf621176d01.svg";